export interface CommonState {
  privateSpaceId: string;
  isInitialized: boolean;
  termsAccepted: boolean;
  analyticsAccepted: boolean;
}

export const initialCommonState: CommonState = {
  privateSpaceId: '',
  isInitialized: false,
  termsAccepted: false,
  analyticsAccepted: false,
};
